module.exports = __webpack_public_path__ + "static/media/ChronosSerif-Filled.2174626c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ChronosSerif-Filled.otf
// module id = 2242
// module chunks = 50